import { render, staticRenderFns } from "./PatientSurvey.vue?vue&type=template&id=3b25c6ca&"
import script from "./PatientSurvey.vue?vue&type=script&lang=js&"
export * from "./PatientSurvey.vue?vue&type=script&lang=js&"
import style0 from "./PatientSurvey.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports